// Cliente de API — siempre usa REACT_APP_BACKEND_URL con prefijo /api
const BASE = process.env.REACT_APP_BACKEND_URL;

async function post(path, body) {
  const res = await fetch(`${BASE}/api${path}`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
  });
  let data = {};
  try {
    data = await res.json();
  } catch (e) {
    data = {};
  }
  if (!res.ok) {
    const msg = data.detail || "No se pudo enviar. Intenta de nuevo.";
    throw new Error(typeof msg === "string" ? msg : "No se pudo enviar.");
  }
  return data;
}

async function get(path) {
  const res = await fetch(`${BASE}/api${path}`);
  if (!res.ok) throw new Error("No se pudo cargar la transmisión.");
  return res.json();
}

// Contacto genérico (CTA de cada página)
export const postContact = ({ sourcePath, name, email, combo, fields }) =>
  post("/contact", { source_path: sourcePath, name, email, combo, fields });

// Onboarding de patrocinadores / marcas
export const postOnboarding = ({ kind, name, email, company, answers }) =>
  post("/onboarding", { kind, name, email, company, answers });
export const postCasaProductora = (payload) => post("/casa-productora", payload);

// ---- Panel de administración ----
export const adminLogin = (email, password) => adminPost("/admin/login", { email, password });

async function adminGet(path) {
  const res = await fetch(`${BASE}/api${path}`, {
    credentials: "include",
  });
  if (res.status === 401) throw new Error("unauthorized");
  if (!res.ok) throw new Error("No se pudo cargar la información.");
  return res.json();
}

async function adminPost(path, body) {
  const res = await fetch(`${BASE}/api${path}`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    credentials: "include",
    body: JSON.stringify(body),
  });
  if (res.status === 401) throw new Error("unauthorized");
  if (!res.ok) throw new Error("No se pudo actualizar la transmisión.");
  return res.json();
}

export const adminSummary = () => adminGet("/admin/summary");
export const adminLeads = () => adminGet("/admin/leads");
export const adminOnboarding = () => adminGet("/admin/onboarding");
export const adminSession = () => adminGet("/admin/session");
export const adminLogout = () => adminPost("/admin/logout", {});
export const getBroadcastState = () => get("/broadcast-state");
export const adminSetBroadcastState = (state) => adminPost("/admin/broadcast-state", state);
